var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"play-button",attrs:{"round":""},on:{"click":_vm.$listeners.click}},[_c('base-icon',{attrs:{"font-size":40,"color":"var(--palette-bg)"}},[_vm._v("sci-play")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }